import { Document, StyleSheet, Text, View, Font } from "@react-pdf/renderer";
import PageLayout from "../../components/Contract/contractPdf/contractService/PageLayout";
import ArabicRegular from "../../../../../src/assets/ArabicFont/IBMPlexSansArabic-Regular.ttf";
import ArabicComponent from "../../../../utils/ArabComponent/ArabicComponent";

Font.register({
  family: "NotoSansArabic",
  src: ArabicRegular, // Ensure this path is correct
});

export default function Costplusimmediate({
  data,
  clientDetails,
  valueChange,
  header,
}) {
  const translateToArabic = (text) => {
    const translations = {
      "Invoice Details": "تفاصيل الفاتـــــــــــــورة",

      "Request Date": "تاريخ الفاتورة الأولية",

      "Request No.": "رقم الفاتورة الأولية",
      "Contract Number #": "رقم العقد",

      candidates: "وديعة تأمين لمدة شهر لـ <XX> مرشح",

      "Total Amount": "المبلغ الإجمالي",
    };

    return translations[text] || text; // Return translated text or original if no translation is found
  };
  const translateToArabicNew = (text) => {
    const translations = {
      "Request Date": "تاريخ الفاتورة الأولية",

      "Request No.": "رقم الفاتورة الأولية",
      "Contract Number #": "رقم العقد",

      candidates: "وديعة تأمين لمدة شهر لـ <XX> مرشح",

      "Total Amount": "المبلغ الإجمالي",
      "Invoice details.": "تفاصيل الفاتـــــــــــــورة",

      "Invoice Date": "تاريخ اصدار الفاتورة",

      "Invoice No.": "رقم الفاتورة",

      "Invoice for": "فاتورة الخدمات المنفذة فى شهر",

      "Customer VAT Number": "الرقــم الضريبــى للعميل",

      "Contract Number #": "رقم العقد",

      "Taxable amount Service charges": "مبلغ خاضع للضريبة",
      "Non-Taxable Amount - SAR": "15قيمة الضريبة%",
      "VAT Amount 15% - SAR": "15قيمة الضريبة%",

      "Total Invoice Amount - SAR": "المبلغ الأجمالى للفاتورة",

      "VAT # for Soundlines Administrative Co.":
        "لرقم الضريبى لشركة ساوندلاينز الإداريه",
    };

    return translations[text] || text; // Return translated text or original if no translation is found
  };

  const styles = StyleSheet.create({
    page: {
      flexDirection: "column",
      backgroundColor: "#E4E4E4",
      padding: 20,
    },
    tableContainer: {
      marginTop: 8,
    },
    tableHeaderLine: {
      borderTopWidth: 1,
      borderTopColor: "#000",
      marginBottom: 0,
    },
    tableRow: {
      flexDirection: "row",
      borderTopWidth: 1, // Line on top of the row
      borderBottomWidth: 1, // Line on bottom of the row
      borderColor: "#000",
      borderStyle: "solid",
    },
    tableCell: {
      flex: 1,
      padding: 6,
      fontSize: 10,
      borderRightWidth: 1, // Divider between cells
      borderColor: "#000",
    },
    firstCell: {
      borderLeftWidth: 1, // Divider on the left side of the first cell
      borderColor: "#000",
    },
    lastCell: {
      flex: 2,
      padding: 6,
      borderLeftWidth: 1, // Divider on the left side of the last cell
      borderRightWidth: 1, // Divider on the right side of the last cell
      borderColor: "#000",
    },
    tableHeader: {
      fontWeight: "bold",
      fontSize: 12,
      padding: 6,
      textAlign: "center",
      borderBottomWidth: 1,
      borderBottomColor: "#000",
    },
    arabicText: {
      fontFamily: "NotoSansArabic",
      textAlign: "right",
      direction: "rtl",
      fontSize: 9,
      margin: 5,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      // textDecoration: "underline",
    },
  });
  console.log("data to be printed here....123456789000", data);
  let uniqueIdCounter = 0;

  const generateUniqueId = () => {
    return `arabic-text-${uniqueIdCounter++}`;
  };
  return (
    <Document>
      <PageLayout size="A4">
        <View style={{ marginBottom: 6, alignItems: "center" }}>
          <Text
            style={{
              fontSize: 15,
              fontWeight: "bold",
              textAlign: "center", // Align text content in the center
            }}
          >
            {header}
          </Text>
        </View>

        <View style={{ marginBottom: 6 }}>
          <Text style={{ fontSize: 12, fontWeight: "bold" }}>Customer:</Text>
        </View>
        <View style={{ marginBottom: 6 }}>
          <Text style={{ fontSize: 10, fontWeight: "bold" }}>
            To:{clientDetails && clientDetails[0]?.customer_name}
          </Text>
        </View>
        <View style={{ marginBottom: 6 }}>
          <Text style={{ fontSize: 10, fontWeight: "bold" }}>
            {clientDetails && clientDetails[0]?.company_registration}
          </Text>
        </View>
        <View style={{ marginBottom: 6 }}>
          <Text style={{ fontSize: 10, fontWeight: "bold" }}>
            {clientDetails && clientDetails[0]?.address}
          </Text>
        </View>
        <View style={{ marginBottom: 6 }}>
          <Text style={{ fontSize: 10, fontWeight: "bold" }}>
            {clientDetails && clientDetails[0]?.po_box}
          </Text>
        </View>
        <View style={{ marginBottom: 6 }}>
          <Text style={{ fontSize: 10, fontWeight: "bold" }}>
            {clientDetails && clientDetails[0]?.pincode}
          </Text>
        </View>

        <View style={{ marginBottom: 6, alignItems: "center" }}>
          <Text
            style={{
              fontSize: 15,
              fontWeight: "bold",
              textAlign: "center", // Align text content in the center
            }}
          >
            INVOICE DETAILS
          </Text>
        </View>

        <View style={styles.tableContainer}>
          {data.map((row, index) => (
            <View key={index} style={styles.tableRow}>
              <Text style={[styles.tableCell, styles.firstCell]}>
                {row.Header} {/* Translate the Header to Arabic */}
              </Text>
              <Text style={styles.tableCell}>{row.value}</Text>

              {/* Check if row.Artabic exists before mapping */}
              {row?.Artabic?.length > 0 && (
                <View style={styles.lastCell} key={generateUniqueId()}>
                  <Text style={styles.arabicText}>
                    {
                      row.Header === "Invoice details."
                        ? "تفاصيل الفاتورة.رة"
                        : row.Header === "Invoice No."
                          ? " سريدهار  "
                          : row.Header === "Invoice for"
                            ? "رقم الفاتورة"
                            : row.Header === "Customer VAT Number"
                              ? "رقم ضريبة القيمة المضافة للعميل"
                              : row.Header === "Contract Number #"
                                ? "رقم العقد #"
                                : row.Header === "Request Date"
                                  ? "تاريخ الطلب"
                                  : row.Header === "Total Amount"
                                    ? "المبلغ الإجمالي"
                                    : row.Header ===
                                        "Taxable amount Service charges"
                                      ? "ص - إجمالي مبلغ الفاتورة"
                                      : row.Header ===
                                          "Non-Taxable Amount - SAR"
                                        ? "المبلغ غير الخاضع للضريبة - ريال سعودي"
                                        : row.Header === "VAT Amount 15% - SAR"
                                          ? "مبلغ ضريبة القيمة المضافة 15% - ريال سعودي"
                                          : row.Header ===
                                              "Total Invoice Amount - SAR"
                                            ? "إجمالي مبلغ الفاتورة - ريال سعودي"
                                            : "المبلغ غير الخاضع للضريبة - ريال سعودي"
                      // <ArabicComponent arabText={row.Artabic} />
                    }
                  </Text>
                  {/* ))} */}
                </View>
              )}
            </View>
          ))}
        </View>
        <View
          style={{
            flexDirection: "row",
            // marginBottom: 10,
            justifyContent: "space-evenly",
            margin: 10,
          }}
        >
          <Text style={{ fontSize: 15, fontWeight: "bold", marginTop: 25 }}>
            Finance Dept.
          </Text>
          <Text style={{ fontSize: 15, fontWeight: "bold", marginTop: 25 }}>
            General Manager.
          </Text>
        </View>
      </PageLayout>
    </Document>
  );
}
